import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 2,
  class: "modal"
}
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = ["disable"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_th = _resolveComponent("b-th")!
  const _component_b_tr = _resolveComponent("b-tr")!
  const _component_b_thead = _resolveComponent("b-thead")!
  const _component_b_td = _resolveComponent("b-td")!
  const _component_b_tbody = _resolveComponent("b-tbody")!
  const _component_b_table_simple = _resolveComponent("b-table-simple")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isContentLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Загрузка..."))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "btn btn-info",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadReport())),
            disabled: _ctx.isLoading
          }, "Выгрузить результат", 8, _hoisted_3),
          _createElementVNode("button", {
            class: "btn btn-success align-items-center justify-content-end",
            disabled: _ctx.isLoading,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showUploadModal = true))
          }, "Загрузить xlsx файл", 8, _hoisted_4),
          _createVNode(_component_b_table_simple, { bordered: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_thead, { "head-variant": "light" }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_tr, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_th, null, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode("#")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_b_th, null, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode("Населенный пункт")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_b_th, null, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode("Тип населенного пункта")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_b_th, null, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode("Сумма")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_b_th, null, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createTextVNode("Год")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_b_tbody, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kindergartenSpecialStandardList, (document, index) => {
                    return (_openBlock(), _createBlock(_component_b_tr, { key: index }, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_td, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(index+1), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_b_td, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(document.kato.nameRu) + " (" + _toDisplayString(document.kato.code) + ")", 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_b_td, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(document.localityType.name) + " (" + _toDisplayString(document.localityType.code) + ")", 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_b_td, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(document.price), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_b_td, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(document.year), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])),
    (_ctx.showUploadModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[11] || (_cache[11] = _createElementVNode("h4", null, "Выберите .xlsx файл для загрузки Номера платежей", -1)),
            _createElementVNode("form", {
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleUploadSubmit && _ctx.handleUploadSubmit(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _cache[10] || (_cache[10] = _createElementVNode("label", {
                  for: "timesheetFile",
                  class: "form-label"
                }, " Выберите .xlsx файл ", -1)),
                _createElementVNode("input", {
                  type: "file",
                  id: "timesheetFile",
                  class: "form-control",
                  required: "",
                  accept: ".xlsx",
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                }, null, 32)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "submit-btn",
                  disable: _ctx.isLoading
                }, _toDisplayString(_ctx.isLoading ? 'Загружается...' : 'Загрузить'), 9, _hoisted_9)
              ])
            ], 32),
            _createElementVNode("button", {
              class: "close-modal-btn",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showUploadModal = false))
            }, "Закрыть")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}